/**
 * @desc 获取分期交易红包
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** transactionId */
  transactionId: number
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/installmentRedpacket',
    params,
    method: 'get',
  })
}
